(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["farm-connect-landing"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('fc-explorer')) {
  customElements.define('fc-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.items = Array.from(this.querySelectorAll('details[data-resource]'));
      this.figures = Array.from(this.querySelectorAll('[data-resource-image]'));
      this.classList.add('is-ready');
      this.items.forEach(item => item.addEventListener('toggle', () => {
        if (item.open) {
          this.items.forEach(other => { if (other !== item) other.open = false; });
          this.syncImage(item);
        } else if (!this.items.some(other => other.open)) {
          this.syncImage(null);
        }
      }, options));
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('details[data-resource]');
        if (item && this.contains(item)) { item.open = true; this.syncImage(item); }
      }, options);
      this.syncImage(this.items.find(item => item.open));
    }
    syncImage(item) {
      const active = item && this.figures.find(figure => figure.dataset.resourceImage === item.dataset.resource);
      this.figures.forEach(figure => { figure.hidden = figure !== active; });
      this.classList.toggle('has-active-image', Boolean(active));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
if (!customElements.get('fc-trailer')) {
  customElements.define('fc-trailer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.details = this.querySelector('details');
      this.mount = this.querySelector('.fc-trailer__mount');
      this.template = this.querySelector('template');
      this.details.addEventListener('toggle', () => {
        if (this.details.open) {
          const scope = this.closest('.fc-shopify-section') || document;
          scope.querySelectorAll('fc-trailer details[open]').forEach(other => { if (other !== this.details) other.open = false; });
          if (!this.mount.hasChildNodes()) this.mount.append(this.template.content.cloneNode(true));
        } else { this.stop(); }
      }, { signal: this.controller.signal });
    }
    stop() { this.mount?.querySelectorAll('video').forEach(video => video.pause()); this.mount?.replaceChildren(); }
    disconnectedCallback() { this.stop(); this.controller?.abort(); this.controller = null; }
  });
}


if (!customElements.get('fc-series-player')) {
  customElements.define('fc-series-player', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = Array.from(this.querySelectorAll('[data-series-panel]'));
      const choices = this.querySelector('.fc-screen__choices');
      choices.replaceChildren();
      this.buttons = this.panels.map((panel, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'fc-screen__choice';
        button.setAttribute('aria-controls', panel.id);
        button.append(panel.querySelector('[data-choice]').content.cloneNode(true));
        button.addEventListener('click', () => this.select(index), options);
        choices.append(button);
        const play = panel.querySelector('.fc-screen__play');
        if (play) {
          play.hidden = false;
          play.addEventListener('click', () => {
            const mount = panel.querySelector('.fc-screen__mount');
            mount.replaceChildren(panel.querySelector('[data-player]').content.cloneNode(true));
            mount.hidden = false;
            panel.querySelector('.fc-screen__poster').hidden = true;
            const player = mount.querySelector('video, iframe');
            if (player) { player.tabIndex = 0; player.focus(); }
            const video = mount.querySelector('video');
            if (video) { const result = video.play(); if (result) result.catch(() => {}); }
          }, options);
        }
        return button;
      });
      choices.hidden = this.panels.length < 2;
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.indexOf(event.target.closest('[data-series-panel]'));
        if (index >= 0) this.select(index);
      }, options);
      this.select(0);
    }
    reset(panel) {
      const mount = panel.querySelector('.fc-screen__mount');
      mount.querySelectorAll('video').forEach(video => video.pause());
      mount.replaceChildren();
      mount.hidden = true;
      panel.querySelector('.fc-screen__poster').hidden = false;
    }
    select(index) {
      this.panels.forEach((panel, i) => {
        if (i !== index) this.reset(panel);
        panel.hidden = i !== index;
        this.buttons[i].setAttribute('aria-pressed', String(i === index));
      });
    }
    disconnectedCallback() {
      this.panels?.forEach(panel => this.reset(panel));
      this.controller?.abort();
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-learning"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fc-learning-tabs')) {
 customElements.define('fc-learning-tabs', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const options = {signal:this.controller.signal};
   this.panels = Array.from(this.querySelectorAll('[data-learning-panel]'));
   const nav = this.querySelector('.fc-learning-tabs__nav');
   nav.replaceChildren(); nav.setAttribute('role','tablist');
   this.tabs = this.panels.map((panel,index) => {
    const tab=document.createElement('button');
    tab.type='button'; tab.className='fc-learning-tabs__tab'; tab.textContent=panel.dataset.title;
    tab.id=panel.id+'-tab'; tab.setAttribute('role','tab'); tab.setAttribute('aria-controls',panel.id);
    panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',tab.id); panel.tabIndex=0;
    tab.addEventListener('click',()=>this.select(index),options);
    tab.addEventListener('keydown',event=>{
     let next=index;
     if(event.key==='ArrowRight') next=(index+1)%this.tabs.length;
     else if(event.key==='ArrowLeft') next=(index-1+this.tabs.length)%this.tabs.length;
     else if(event.key==='Home') next=0;
     else if(event.key==='End') next=this.tabs.length-1;
     else return;
     event.preventDefault(); this.select(next); this.tabs[next].focus();
    },options);
    nav.append(tab); return tab;
   });
   nav.hidden=this.tabs.length<2;
   this.nav=nav;
   this.previous=this.querySelector('[data-learning-prev]');
   this.next=this.querySelector('[data-learning-next]');
   this.counter=this.querySelector('.fc-learning-tabs__count');
   this.querySelector('.fc-learning-tabs__mobile-controls').hidden=this.tabs.length<2;
   this.previous.addEventListener('click',()=>this.select(Math.max(0,this.activeIndex-1)),options);
   this.next.addEventListener('click',()=>this.select(Math.min(this.tabs.length-1,this.activeIndex+1)),options);
   this.resizeObserver=new ResizeObserver(()=>{this.setEndSpace();this.alignTab(false);});
   this.resizeObserver.observe(nav);
   this.addEventListener('shopify:block:select',event=>{
    const index=this.panels.indexOf(event.target.closest('[data-learning-panel]'));
    if(index>=0) this.select(index);
   },options);
   this.setEndSpace(); this.select(0,false); this.classList.add('is-ready');
  }
  setEndSpace(){
   const last=this.tabs[this.tabs.length-1];
   if(last)last.style.marginRight=window.matchMedia('(max-width:749px)').matches?Math.max(0,this.nav.clientWidth-last.offsetWidth)+'px':'';
  }
  alignTab(animate=true){
   const tab=this.tabs[this.activeIndex];
   if(!tab)return;
   const nav=this.nav;
   if(window.matchMedia('(max-width:749px)').matches){
    nav.scrollTo({left:tab.offsetLeft,behavior:animate&&!window.matchMedia('(prefers-reduced-motion:reduce)').matches?'smooth':'instant'});
   }else{
    const left=tab.offsetLeft;
    if(left<nav.scrollLeft)nav.scrollLeft=left;
    else if(left+tab.offsetWidth>nav.scrollLeft+nav.clientWidth)nav.scrollLeft=left+tab.offsetWidth-nav.clientWidth;
   }
  }
  select(index,animate=true) {
   this.activeIndex=index;
   this.panels.forEach((panel,i)=>{
    panel.hidden=i!==index;
    this.tabs[i].setAttribute('aria-selected',String(i===index));
    this.tabs[i].tabIndex=i===index?0:-1;
   });
   this.previous.disabled=index<=0;
   this.next.disabled=index>=this.tabs.length-1;
   this.counter.textContent=this.tabs.length?(index+1)+' / '+this.tabs.length:'';
   this.alignTab(animate);
  }
  disconnectedCallback(){this.resizeObserver?.disconnect();this.controller?.abort();this.controller=null;}

 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	function btyHeaderSticky( doc = document ) {
		let hasTopbar = document.querySelector( '.topbar-section ~ .header-section' ),
			header    = doc.querySelector( '.header.transparent-header' );

		function onShopifyLoaded( callback ) {
			if ( ! header ) {
				setTimeout(
					function() {
						onShopifyLoaded( callback )
					}
				);

				return;
			}

			callback();
		}

		onShopifyLoaded(
			function() {
				if ( ! header ) {
					return;
				}

				const detectScroll = function() {
					if ( window.scrollY > 50 ) {
						header.classList.add( 'is-sticky' );
					} else {
						header.classList.remove( 'is-sticky' );
					}
				}

				if ( Shopify.designMode || ! hasTopbar ) {
					detectScroll();
					window.addEventListener( 'scroll', detectScroll );
				} else {
					const observer = new IntersectionObserver(
						([e]) => e.target.classList.toggle( 'is-sticky', e.intersectionRatio < 1 ),
						{
							rootMargin: '-1px 0px 0px 0px',
							threshold: [1]
						}
					);

					observer.observe( header );
				}
			}
		)
	}

	btyHeaderSticky();

	document.addEventListener(
		'shopify:section:select',
		function( e ) {
			let section = e.target;
			btyHeaderSticky( section );
		}
	);

	document.addEventListener(
		'shopify:block:select',
		function( e ) {
			let section = document.getElementById( 'shopify-section-' + e.detail.sectionId );
			btyHeaderSticky( section );
		}
	);

  } catch(e) { console.error(e); }
})();
})();
